import React from 'react';
import Contact from './Contact';
import AddNew from '../../components/AddNew';


const ContactsList = (props) => {
  if (props.didMount !== true) {
    return (
      <div>loading...</div>
    )
  }
  if (props.contacts === null || props.contacts.length < 1) {
    return (
      <div>
        No contacts found.
        {/* no contacts found{props.searchTerm ? ` for '${props.searchTerm}'.` : '.' } */}
      </div>
    )
  }


  return [{}].concat(props.contacts).map(
    (contact, i) =>
      i === 0
        ? <AddNew
            key={"new"}
            href={"/notes/new"}
            name={"Create a new contact"}
            clickAdd={props.click}
          />
        : <Contact
            key={contact._source.contactId}
            contact={contact}
            click={props.click}
          />
  );
}

export default ContactsList;



// WEBPACK FOOTER //
// ./src/containers/Contacts/ContactsList.js